import { useState, useEffect, useMemo } from 'react'
import { storage, cookie } from '@/hooks/useIknow'
import { useSelector } from 'umi'

const getValueListByKey = (key, location) => {
    const valueList = location.get(key)
    if (valueList) {
        return valueList
    } else {
        return []
    }
}

export const get = (name, latitude, location) => {
    if (!latitude || !name) return false
    let keyList = getValueListByKey(name, location)
    if (keyList?.indexOf?.(latitude) !== -1) {
        return true
    }
    return false
}

// latitude: 默认用户uid存
// name:要存的key值
// length: 存放list的最大长度，超出会从list第一个开始删除旧的
// saveLocation 存储位置 默认storage 可选cookie
export default ({ name = '', latitudeType = '', length = 15, saveLocation = 'storage' }) => {
    const location = saveLocation === 'cookie' ? cookie : storage
    let latitude = latitudeType
    const uid = useSelector(state => state?.user?.currentUser?.uid)

    if (!latitudeType) {
        latitude = uid
    }

    useEffect(() => {
        if (latitude) {
            setIsRecord(get(name, latitude, location))
        }
    }, [latitude, location, name])

    const [isRecord, setIsRecord] = useState(() => {
        return true
    })

    const saveRecordStatus = data => {
        setIsRecord(data)
        if (latitude && name) {
            if (data) {
                set()
            } else {
                remove()
            }
        }
    }
    const getRecordStatus = () => {
        return get(name, latitude, location)
    }
    // 通过存放的name对应的value值是否是undefined， 来区分 是否是进入页面用户未操作过，因为有些会要求进入页面默认是不弹出的。
    // 当用户点击之后，下次进入会根据此次打开/关闭状态来展示
    const isUserNoOperation = useMemo(() => {
        return !location.get(name)
    }, [location, name])
    // 初始化存储的name对应值，undefined ==> key: [], 代表用户操作过
    const initUserOperation = () => {
        location.set(name, [])
    }

    const set = () => {
        let keyList = getValueListByKey(name, location)
        if (keyList.indexOf(latitude) !== -1) {
            return
        } else {
            keyList.push(latitude)
            if (keyList.length > length) {
                keyList.shift()
            }
        }
        location.set(name, keyList)
    }

    const remove = () => {
        let keyList = getValueListByKey(name, location)
        if (keyList.indexOf(latitude) !== -1) {
            // 找到元素并且删除
            keyList.splice(
                keyList.findIndex(item => item === latitude),
                1
            )
            location.set(name, keyList)
        }
    }

    return {
        isRecord,
        isUserNoOperation,
        initUserOperation,
        saveRecordStatus,
        getRecordStatus
    }
}
